export const variantsAndCrossSectionsQuery = (projectId, variantId) => {
  return {
    tables: [
      {
        name: 'CFFA_RPI_VARIANTS',
        project: projectId,
        as: 'variants',
        records: [variantId],
        columns: [
          {
            name: 'name',
          },
          {
            name: 'contact',
          },
          {
            name: 'construction_date',
          },
          {
            name: 'image',
          },
        ],
      },
      {
        name: 'CFFA_RPI_CROSS_SECTIONS',
        project: projectId,
        as: 'crossSections',
        sortBy: 'title',
        columns: [
          {
            name: 'variant',
            conditions: [
              {
                operator: '=',
                value: variantId,
              },
            ],
          },
          {
            name: 'title',
          },
          {
            name: 'image',
          },
          {
            name: 'coverage_ratio',
          },
          {
            name: 'score',
          },
          {
            name: 'score_revision_time',
          },
        ],
      },
    ],
  };
};
export const crossSectionComponentsQuery = (projectId, crossSectionId) => {
  return {
    tables: [
      {
        name: 'CFFA_RPI_COMPONENTS',
        project: projectId,
        as: 'components',
        sortBy: 'nr',
        columns: [
          {
            name: 'cross_section',
            conditions: [
              {
                operator: '=',
                value: crossSectionId,
              },
            ],
          },
          {
            name: 'nr',
          },
          {
            name: 'name',
          },
          {
            name: 'description',
          },
          {
            name: 'status',
          },
          {
            name: 'product_lvl',
          },
          {
            name: 'component_function',
          },
          {
            name: 'component_additional_function',
          },
          {
            name: 'building_function',
          },
          {
            name: 'building_additional_function',
          },
          {
            name: 'generic_component',
          },
          {
            name: 'construction_date_deviation',
          },
          {
            name: 'technical_lifespan',
          },
        ],
      },
    ],
  };
};

export const connectionsByComponentsQuery = (projectId, componentIds) => {
  return {
    tables: [
      {
        name: 'CFFA_RPI_COMPONENTS_CONNECTIONS',
        project: projectId,
        as: 'connections',
        columns: [
          {
            name: 'to_component',
          },
          {
            name: 'from_component',
            conditions: [
              {
                operator: '=',
                values: componentIds,
              },
            ],
          },
          {
            name: 'type',
          },
        ],
      },
    ],
  };
};
export const connectionTypes = [
  {
    type: 'A1',
    label: 'Gravity',
  },
  {
    type: 'A2',
    label: 'Gravity with fastening',
  },
  {
    type: 'A3',
    label: 'Intermediary',
  },
  {
    type: 'B1',
    label: 'Direct form-locking (interlock, click, wedge)',
  },
  {
    type: 'B2',
    label: 'Form-lock with fastening (bracket, glazing bead, clamp)',
  },
  {
    type: 'C1',
    label: 'Direct two-sided access (bolt-nut)',
  },
  {
    type: 'C2',
    label: 'Single-sided access with thread (screw)',
  },
  {
    type: 'C3',
    label: 'Single-sided access without thread (nail)',
  },
  {
    type: 'C4',
    label: 'Hidden dowel',
  },
  {
    type: 'C5',
    label: 'Irreversible single-sided access (rivet, crimper)',
  },
  {
    type: 'D1',
    label:
      'Material connection weaker than the connected part (mortar, glue, tape, weld)',
  },
  {
    type: 'D2',
    label:
      'Covering material connection, weaker than connected part (paint, plaster, screed)',
  },
  {
    type: 'D3',
    label: 'Material connection stronger than connected part (cement)',
  },
  {
    type: 'D4',
    label:
      '(Covering) material connection, stronger than connected part (in-situ concrete)',
  },
];
